import { Component, OnInit } from '@angular/core';
import { TabName } from '../../../models/_enum-collections';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { SpecialInvestmentTableComponent } from '../../shared/special-investment-table/special-investment-table.component';

@Component({
  selector: 'app-customer-surveys-queue',
  templateUrl: './customer-surveys-queue.component.html',
  styleUrls: ['./customer-surveys-queue.component.scss'],
  standalone: true,
  imports: [SpecialInvestmentTableComponent]
})
export class CustomerSurveysQueueComponent implements OnInit {
  tabName!: number;
  prevDocumentType!: string;

  ngOnInit() {
    this.tabName = TabName.CustomerSurveyReview;
    this.prevDocumentType = PreviewDocumentTypes.customerSurvey;
  }
}
